// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upsell-card--zM1oO{border:1px solid #ffe49a;border-radius:12px;background-color:#fff3cb}.price--zuQaJ,.description--nRrcw{color:#5a6272}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upsell-card": "upsell-card--zM1oO",
	"price": "price--zuQaJ",
	"description": "description--nRrcw"
};
export default ___CSS_LOADER_EXPORT___;
